/* eslint-disable no-shadow */
export enum ContentType {
  Page = "page",
  Quiz = "quiz",
  Poll = "poll",
  Event = "event",
  Vod = "vod",
  Article = "article",
}

export const NOTIFICATION_PERMISSION = {
  category: "Common",
  subCategory: "Notification",
  action: "Notification",
};

export const CONTENT_STATUS_PERMISSION = {
  category: "Common",
  subCategory: "ContentStatus",
  action: "ContentStatus",
};
